import Genre from "../../sections/Genre/Genre";
import Hero from "../../sections/Hero/Hero";
import NewReleases from "../../sections/NewReleases/NewReleases";
import TopSales from "../../sections/TopSales/TopSales";
import Featured from "../../sections/Featured/Featured";
import "./Home.css";

function Home() {
  return (
    <main className="Home">
      <Hero />
      <Genre />
      <TopSales />
      <NewReleases />
      <Featured />
    </main>
  );
}

export default Home;
